import { QUANTITY_UNIT, hasSelectedItems, parseCustomQuantity } from '@/components/Tickets/materialsOrderSelection';

export const UNITS_MODE = 'units';
export const BOXES_MODE = 'boxes';

const BOX_SINGULAR = 'caja';
const BOX_PLURAL = 'cajas';
const SINGLE_BOX = 1;
const MINIMUM_PREFIX = 'Mínimo';
const THOUSANDS_GROUPS = /\B(?=(\d{3})+(?!\d))/g;
const THOUSANDS_SEPARATOR = '.';
const NO_TEXT = '';
const CONVERTED_PREFIX = '=';

function formatUnits(quantity) {
  return `${String(quantity).replace(THOUSANDS_GROUPS, THOUSANDS_SEPARATOR)} ${QUANTITY_UNIT}`;
}

function boxesLabel(boxes) {
  return `${boxes} ${boxes === SINGLE_BOX ? BOX_SINGULAR : BOX_PLURAL}`;
}

function isWholeBoxes(quantity, item) {
  return hasUnitsPerBox(item) && quantity % item.units_per_box === 0;
}

export function hasUnitsPerBox(item) {
  return Number.isInteger(item.units_per_box) && item.units_per_box > 0;
}

export function presetChip(preset, item) {
  if (!isWholeBoxes(preset, item)) return { label: String(preset), hint: NO_TEXT };

  return { label: boxesLabel(preset / item.units_per_box), hint: formatUnits(preset) };
}

export function customQuantityToUnits(rawValue, mode, item, maxQuantity) {
  const typed = parseCustomQuantity(rawValue, Number.MAX_SAFE_INTEGER);
  if (typed === null) return null;

  const quantity = mode === BOXES_MODE && hasUnitsPerBox(item) ? typed * item.units_per_box : typed;
  return parseCustomQuantity(String(quantity), maxQuantity);
}

export function unitsToModeText(quantity, mode, item) {
  if (quantity === null) return NO_TEXT;
  if (mode === UNITS_MODE) return String(quantity);

  return isWholeBoxes(quantity, item) ? String(quantity / item.units_per_box) : NO_TEXT;
}

export function minimumMessage(item) {
  if (!Number.isInteger(item.min_quantity) || item.min_quantity <= 0) return NO_TEXT;
  if (!isWholeBoxes(item.min_quantity, item)) return `${MINIMUM_PREFIX} ${formatUnits(item.min_quantity)}`;

  return `${MINIMUM_PREFIX} ${boxesLabel(item.min_quantity / item.units_per_box)} (${formatUnits(item.min_quantity)})`;
}

export function isBelowMinimum(item, quantity) {
  return Number.isInteger(item.min_quantity) && quantity !== null && quantity < item.min_quantity;
}

export function hasQuantityBelowMinimum(items, selection) {
  return items.some((item) => selection[item.material_id] !== undefined && isBelowMinimum(item, selection[item.material_id]));
}

export function isOrderReadyToSend(items, selection) {
  return hasSelectedItems(selection) && !hasQuantityBelowMinimum(items, selection);
}

export function modeUnitLabel(mode) {
  return mode === BOXES_MODE ? BOX_PLURAL : QUANTITY_UNIT;
}

export function isQuickButtonsEnabled(catalog) {
  return !catalog || catalog.quick_buttons !== false;
}

export function entryRowModel({ item, mode, text, maxQuantity }) {
  const effectiveMode = hasUnitsPerBox(item) ? mode : UNITS_MODE;
  const quantity = customQuantityToUnits(text, effectiveMode, item, maxQuantity);
  const hint = effectiveMode === BOXES_MODE && quantity !== null ? `${CONVERTED_PREFIX} ${formatUnits(quantity)}` : NO_TEXT;

  return { quantity, hint, unitLabel: modeUnitLabel(effectiveMode), isInvalid: text !== NO_TEXT && quantity === null };
}
